<template>
  <div class="bet" :class="{ open: open }">
    <div class="bet-hat flex" @click="open = !open">
      <div class="bet-number">{{ bet.number }}</div>
      <div class="bet-placed-time">{{ bet.placed }}</div>
      <div class="bet-type">{{ bet.type }}</div>
      <div class="bet-factor" :class="{ [bet.statusColor + '-color']: true }">{{ bet.factor }}</div>
      <div class="bet-amount">{{ bet.amount }} {{ $store.state.user.currency }}</div>
      <div class="bet-status flex">
        <div class="bet-status-name" :class="{ [bet.statusColor + '-color']: true }">{{ bet.statusName }}</div>
        <div class="bet-winning" v-if="[ 'placed', 'won', 'vip' ].indexOf(bet.status) !== -1">{{ bet.winning }} {{ $store.state.user.currency }}</div>
      </div>
      <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
    </div>
    <div class="position-list" v-show="open">
      <div class="position flex" v-for="position in bet.positions" :key="position.id">
        <div class="position-time">{{ position.time }}</div>
        <div class="position-info flex">
          <div class="position-info-icon">
            <sport-icon :name="position.sport" />
          </div>
          <div class="position-info-text">
            <div class="position-league">
              <span class="red-color" v-if="position.live">Live.</span>
              {{ position.sportName }}.
              {{ position.league }}
            </div>
            <div class="orange-color" v-if="position.kind">{{ position.kind }}</div>
            <div class="position-event">{{ position.name }}</div>
            <div class="position-outcome">{{ position.outcome }}</div>
          </div>
        </div>
        <div class="position-factor" :class="{ [position.statusColor + '-color']: true }">{{ position.factor }}</div>
        <div class="position-result">{{ position.result }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIcon from '@/components/icons/SportIcon'

export default {
  components: {
    ArrowIcon,
    SportIcon
  },
  props: {
    bet: Object
  },
  data () {
    return {
      statuses: [ 'placed', 'lost', 'won', 'refunded', 'vip', 'rejected' ],
      open: false
    }
  }
}
</script>

<style scoped>
.bet { overflow: hidden; position: relative; background: rgba(0,0,0,.05); border-radius: 10px; }

.bet-hat { align-items: center; cursor: pointer; padding-left: 10px; text-align: center; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; border-radius: 10px; }
.bet-hat:hover { background: rgba(255, 255, 255, .075); }
.bet-hat > div { flex-shrink: 0; }
.bet-number { width: 50px; }
.bet-placed-time { width: 110px; }
.bet-type { flex: 1; }
.bet-factor { width: 50px; }
.bet-amount { width: 100px; }
.bet-status { width: 250px; }
.bet-status-name { flex: 1; text-align: left; }

.position { align-items: center; background: rgba(0,0,0,.05); margin-top: 1px; padding: 8px 10px; text-align: center; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; }
.position-time { width: 120px; color: #342d6e; }
.position-info { align-items: center; flex: 1; padding-right: 10px; text-align: left; }
.position-info-icon { flex-shrink: 0; height: 16px; margin: 0 12px; width: 16px; }
.position-info-text { flex: 1; }
.position-league { font-size: 12px; }
.position-outcome { color: #713592; }
.position-factor { width: 50px; }
.position-result { width: 380px; }
</style>



// WEBPACK FOOTER //
// src/components/account/bets/Bet.vue